<template>
  <div class="margin-top-10 h-100">
    <div class="text-left">
      <el-button @touchstart="() => openDialog('add',{})" @click="() => openDialog('add',{})"
                 icon="el-icon-circle-plus-outline"
                 size="mini" type="primary">
        新增
      </el-button>
    </div>
    <el-row style="height: calc(100% - 80px)">
      <el-table
        :data="userList"
         size="mini"
         border
        class="table no-row-border"
        style="width: 100%;max-height: 100%;margin-top: 10px;overflow-y: auto">
        <el-table-column
          align="center"
          label="序号"
          width="100"
          type="index">
        </el-table-column>
        <el-table-column
          align="center"
          label="卡号"
          prop="card">
        </el-table-column>
        <el-table-column
          align="center"
          label="用户名"
          prop="name">
        </el-table-column>
        <el-table-column
          align="center"
          label="工号"
          prop="number">
        </el-table-column>
        <el-table-column
          align="center"
          label="部门"
          prop="section">
        </el-table-column>
        <el-table-column
          align="center"
          label="照片"
          prop="photo">
          <template slot-scope="scope">
            <div style="width: 40px;height: 40px;margin: auto">
              <img :src="scope.row.photo" style="max-height: 38px;">
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
              <span class="pointer text-blue" @touchstart="() => openDialog('edit',scope.row)"  @click="() => openDialog('edit',scope.row)">
                <i class="el-icon-edit" style="margin-right: 5px"></i>编辑
              </span>
              <span class="pointer text-red margin-left-10" @touchstart="deleteUser(scope.row)" @click="deleteUser(scope.row)">
                <i class="el-icon-delete" style="margin-right: 5px"></i>删除
              </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>


    <dialog-component :width="width"
                      :closeClick="false"
                      :dialogVisible.sync="dialogVisible"
                      :pressClick="false"
                      :showClose="true"
                      @dialogClose="(data) => {this.dialogVisible = data;this.dialogData = {}}"
                      :dialog-title="title">
      <div slot="content">
        <div style="height: 35vh;margin: 30px;overflow-y: auto">
          <el-row>
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">卡号：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.card" type="number" placeholder="请输入卡号"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">工号：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.number" type="number" placeholder="请输入工号"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">密码：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.password" type="password" placeholder="请输入密码"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">部门：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-select
                v-model="dialogData.sectionid"
                placeholder="请选择部门"
                size="mini"
                style="width: 100%">
                <el-option
                  v-for="item in sectionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">用户名：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <el-input size="mini" v-model="dialogData.name" placeholder="请输入用户名"></el-input>
            </el-col>
          </el-row>
          <el-row class="margin-top-15">
            <el-col :lg="6" :md="5" :sm="6" :xs="5" class="form-label-color2 text-right  line-height-26">照片：</el-col>
            <el-col :lg="14" :md="15" :sm="15" :xs="17">
              <input size="mini"
                     type="file" ref="imgFile"
                     accept="image/png,image/jpeg,image/gif,image/jpg"
                     @change="uploadImg()" />
              <div style="width: 80px;height: 80px;text-align: center;position: relative;
              display: grid;justify-content: center;align-items: center;"
                   class="border-dash margin-top-5">
                <img :src="dialogData.photo" style="max-width: 75px;max-height: 75px">
                <!--<i class="el-icon-delete text-red pointer"
                   @click="() => {this.dialogData.photo = null}"
                   style="position: absolute;right: 2px;top: 3px"></i>-->
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div slot="footer" style="text-align: center;margin-bottom: 30px">
        <el-button type="primary" plain size="mini" @touchstart="closeDialog" @click="closeDialog">取消</el-button>
        <el-button type="primary" size="mini" @touchstart="confirm" @click="confirm">确认</el-button>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import DialogComponent from "@/components/DialogComponent";
import _ from 'lodash'

export default {
  name: "User",
  props: ['userList', 'sectionList'],
  components: {DialogComponent},
  data() {
    return {
      dialogVisible: false,
      width: "40vw",
      title: "",
      dialogData: {},
    }
  },
  methods: {
    openDialog(operate, row) {
      this.dialogData = _.cloneDeep(row)
      if (operate === 'add') {
        this.title = '新增用户'
      } else {
        this.title = '编辑用户'
      }
      this.dialogVisible = true
    },
    deleteUser(row) {
      this.$confirm('是否确认删除' + row.name, {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.$emit('userOperation', row, 'delete')
          }
        }
      })
    },
    closeDialog() {
      this.dialogVisible = false;
      this.dialogData = {}
    },
    confirm() {
      if (!this.dialogData.card) {
        this.$message.error("请输入卡号!")
        return false
      }
      if (!this.dialogData.number) {
        this.$message.error("请输入工号!")
        return false
      }
      if (!this.dialogData.sectionid) {
        this.$message.error("请选择部门!")
        return false
      }
      if (this.dialogData.name === undefined || this.dialogData.name.trim() === "") {
        this.$message.error("请输入用户名!")
        return false
      }
      this.$emit('userOperation', this.dialogData)
    },
    uploadImg() {
      let fr = new FileReader();
      const file = this.$refs.imgFile.files[0]
      fr.readAsDataURL(file)
      const that = this
      fr.onload = function (e) {
        that.dialogData.photo = e.currentTarget.result
      }
    },
  }
}
</script>

<style scoped>

</style>
